import { useQuery } from '@apollo/client';
import * as Sentry from '@sentry/react';

import GetSkillAttainmentByOccupationGroupAndCareerBandQuery from 'bundles/skills-common/shared/verified-skills/data/skill-pathway/GetSkillAttainmentByOccupationGroupAndCareerBandQuery.graphql';
import type {
  GetSkillAttainmentByOccupationGroupAndCareerBandQuery as QueryResult,
  GetSkillAttainmentByOccupationGroupAndCareerBandQueryVariables as QueryVariables,
} from 'bundles/skills-common/shared/verified-skills/data/skill-pathway/__generated__/GetSkillAttainmentByOccupationGroupAndCareerBandQuery';

type Props = {
  occupationGroupId?: QueryVariables['occupationGroupId'];
  careerBand?: QueryVariables['careerBand'];
  skip?: boolean;
};

const useGetSkillAttainmentByOccupationGroupAndCareerBand = ({ occupationGroupId, careerBand, skip }: Props) => {
  const { data, loading, error, refetch } = useQuery<QueryResult, QueryVariables>(
    GetSkillAttainmentByOccupationGroupAndCareerBandQuery,
    {
      variables: {
        occupationGroupId: occupationGroupId || '',
        careerBand: careerBand || 'EARLY_CAREER_PROFESSIONAL',
      },
      skip: skip || !occupationGroupId || !careerBand,
      fetchPolicy: 'network-only',
      context: {
        clientName: 'gatewayGql',
      },
      notifyOnNetworkStatusChange: true,
    }
  );

  if (error) {
    Sentry.captureException(error);

    return {
      skillAttainments: [],
      loading: false,
    };
  }

  return {
    skillAttainments: data?.VerifiedSkillsAttainment?.skillAttainmentByOccupationGroupAndCareerBand,
    refetchSkillAttainments: refetch,
    loading,
  };
};

export default useGetSkillAttainmentByOccupationGroupAndCareerBand;
